import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_ORCAMENTO = [
  {
    module: 'ORCAMENTO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'pre_cadastro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'vendedor.parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'previsao_entrega',
        active: true,
        removable: true
      },
      {
        field: 'referencia',
        active: true,
        removable: true
      },
      {
        field: 'modelo.descricao',
        active: true,
        removable: true
      },
      {
        field: 'tabela_preco_fabrica.descricao',
        active: true,
        removable: true
      },
      {
        field: 'precificacao.valor_final_unitario',
        active: true,
        removable: true
      },
      {
        field: 'precificacao.quantidade',
        active: true,
        removable: true
      },
      {
        field: 'precificacao.valor_total_pedido',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'CONTROLE_ORCAMENTO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'pre_cadastro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'vendedor.parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'previsao_entrega',
        active: true,
        removable: true
      },
      {
        field: 'referencia',
        active: true,
        removable: true
      },
      {
        field: 'modelo.descricao',
        active: true,
        removable: true
      },
      {
        field: 'tabela_preco_fabrica.descricao',
        active: true,
        removable: true
      },
      {
        field: 'precificacao.valor_final_unitario',
        active: true,
        removable: true
      },
      {
        field: 'precificacao.quantidade',
        active: true,
        removable: true
      },
      {
        field: 'precificacao.valor_total_pedido',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
